import { Pipe, PipeTransform } from '@angular/core';
import { OrderItem } from '../../core/models/customer/order';

/**
 * Returns the item names as a string. Eg.: "T-Shirt, Hat, Hoodie"
 */
@Pipe({ name: 'evGroupOrderItems',  pure: false })
export class GroupOrderItemsPipe implements PipeTransform {
  /**
   * Returns the item names as a string. If there are more than 5 items,
   * it appends three dots at the end: ...
   *
   * @param items Array of order items.
   * @param args Any additional arguments
   */
  public transform(items: Array<OrderItem>, args: Array<any> = null): string {
    let groupedItems: string = '';
    for (const item of items) {
      if (groupedItems.length > 0) {
        groupedItems += ', ';
      }

      groupedItems += `${item.name}`;

      if (item.quantity > 1) {
        groupedItems += ` (${item.quantity}x)`;
      }
    }

    return groupedItems;
  }
}
